import blanco from './blanco'

export const themes = {
  blanco,
}
